import React from 'react'

const BackgroundImage = ({ blok }) => {
  return (
      <div className='background-image' style={{
        backgroundImage: `url(${blok.background_image.filename})`,
        backgroundSize: blok.size,
        backgroundPosition: `${blok.custom_position_horizontal ? `${blok.custom_position_horizontal}%` : blok.position_horizontal} ${blok.custom_position_vertical ? `${blok.custom_position_vertical}%` : blok.position_vertical}`
      }}
      />
  )
}

export default BackgroundImage